<script>
  import { router, inertia } from '@inertiajs/svelte';
  import Icon from '@iconify/svelte';
  import AppLayout from '../../components/AppLayout.svelte';
  import Card from '../../components/ui/Card.svelte';
  import Button from '../../components/ui/Button.svelte';
  import ConfirmDialog from '../../components/ui/ConfirmDialog.svelte';
  import StatusBadge from '../../components/StatusBadge.svelte';

  let { social_accounts = [] } = $props();

  let pendingDisconnect = $state(null);
  let disconnectError = $state(null);

  function disconnect() {
    const acc = pendingDisconnect;
    disconnectError = null;
    router.delete(`/social_accounts/${acc.id}`, {
      onError: () => { disconnectError = `Could not disconnect ${acc.platform}. Please try again.`; },
      onFinish: () => { pendingDisconnect = null; },
    });
  }
</script>

<AppLayout title="Connected accounts">
  <div class="flex justify-end mb-6">
    <Button href="/social_accounts/new"><Icon icon="mdi:plus" class="mr-1" /> Connect account</Button>
  </div>

  {#if disconnectError}
    <div role="alert" class="rounded-xl border border-red-200 bg-red-50 text-red-700 px-4 py-3 mb-6 text-sm">
      {disconnectError}
    </div>
  {/if}

  <ConfirmDialog
    open={!!pendingDisconnect}
    title="Disconnect account?"
    body={pendingDisconnect ? `Disconnect ${pendingDisconnect.platform} ${pendingDisconnect.handle}? You can reconnect it later.` : ''}
    confirmLabel="Disconnect"
    onconfirm={disconnect}
    oncancel={() => { pendingDisconnect = null; }}
  />

  {#if social_accounts.length === 0}
    <Card>
      <div class="text-center py-8">
        <Icon icon="mdi:account-multiple-outline" class="text-4xl text-secondary-300 mx-auto mb-3" />
        <p class="text-secondary-500 mb-4">No social accounts connected yet.</p>
        <Button href="/social_accounts/new">Connect your first account</Button>
      </div>
    </Card>
  {:else}
    <Card>
      <ul class="flex flex-col divide-y divide-secondary-100">
        {#each social_accounts as acc}
          <li class="flex items-center justify-between py-4 first:pt-0 last:pb-0">
            <div class="flex items-center gap-3">
              <div class="w-10 h-10 rounded-xl bg-secondary-100 flex items-center justify-center text-secondary-600">
                <Icon icon={`mdi:${acc.platform}`} />
              </div>
              <div>
                <div class="font-semibold text-secondary-800 capitalize">{acc.platform}</div>
                <div class="text-sm text-secondary-500">{acc.handle}</div>
              </div>
            </div>
            <div class="flex items-center gap-4">
              <StatusBadge status={acc.status} />
              <button
                onclick={() => { pendingDisconnect = acc; }}
                aria-label={`Disconnect ${acc.platform} ${acc.handle}`}
                class="text-secondary-400 hover:text-red-600 p-2 -m-2"
              >
                <Icon icon="mdi:link-off" />
              </button>
            </div>
          </li>
        {/each}
      </ul>
    </Card>
  {/if}
</AppLayout>
